import {useRecoilValue} from 'recoil';

import {Features} from '@lexian/api/support-api';
import {featureFlagState} from '_/state/featureFlags';

export type PossibleFeatureFlagsType = keyof Features;

/**
 * @returns if the feature flag is active
 */
export const useFeatureFlagCheck = (
  flagName: PossibleFeatureFlagsType | undefined
): boolean => {
  const checkFeatureFlag = useIsFeatureVisible();
  return checkFeatureFlag(flagName);
};

/**
 *@returns callback to check if a feature is visible resp. a feature flag is active
 */
export const useIsFeatureVisible = (): ((
  flag: PossibleFeatureFlagsType | undefined
) => boolean) => {
  const featureFlags = useRecoilValue(featureFlagState);

  return (flag: PossibleFeatureFlagsType | undefined) =>
    featureFlags && (!flag || featureFlags[flag]);
};
